var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("WebcallDataProvider", {
    attrs: {
      "fetch-fn": _vm.fetchVideos,
      "initial-data": [],
      "data-ui-section": "vertical-videos-container"
    },
    on: {
      update: function($event) {
        return _vm.handleDataUpdate($event.data)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var isLoading = ref.isLoading
          return [
            _c(
              "WebcallDataProvider",
              {
                attrs: { "fetch-fn": _vm.fetchInfo },
                on: {
                  update: function($event) {
                    return (_vm.hasFrontSlide = !!$event.data)
                  }
                }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "vertical-container",
                    attrs: {
                      "is-loading": isLoading || _vm.videos.length === 0
                    }
                  },
                  [
                    _c(
                      "h4",
                      { staticClass: "tab-title title text-md-uppercase" },
                      [_vm._v("\n          Recommended Films\n        ")]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.videos, function(video) {
                      return _c("VideoCard", {
                        key: video.id,
                        attrs: {
                          item: video,
                          transformer:
                            _vm.relatedVideoEndpoint.videoTransformer,
                          tracker: _vm.createTracker(video)
                        }
                      })
                    })
                  ],
                  2
                )
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }